import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { Clipboard } from '@angular/cdk/clipboard';
import { CurrencyDto } from 'src/app/domain/models/dto/currency.dto';
import { CurrencyService } from 'src/app/shared/services/currency.service';
import { NotifierService } from 'angular-notifier';
import { CreateOrderInboundDto } from 'src/app/domain/models/dto/create-order.dto';
import { MoedasInbound } from 'src/app/domain/constants/moeda.constant';
import { CountryDto } from 'src/app/domain/models/dto/country.dto';
import { CountriesService } from 'src/app/shared/services/countries.service';
import { AuthenticationService } from 'src/app/shared/services';

@Component({
  selector: 'app-confirm-info',
  templateUrl: './confirm-info.component.html',
  styleUrls: ['./confirm-info.component.scss'],
})
export class ConfirmInfoComponent implements OnInit {
  @Input('currency') currency?: string;
  @Input('loading') loading?: boolean;
  @Input('orderDetails') orderDetails?: CreateOrderInboundDto;
  @Output('goBack') goBack: EventEmitter<any> = new EventEmitter();
  @Output('saveOrder') saveOrder: EventEmitter<any> = new EventEmitter();
  @Output('closeModal') closeModal: EventEmitter<any> = new EventEmitter();

  currencyDetails?: CurrencyDto;
  currencyDetails$?: Subscription;
  private readonly notifier: NotifierService;
  moedas = MoedasInbound;
  orderCurrency: CurrencyDto;
  orderCountry: CountryDto;
  isMobile = false;
  get companyId() {
    return +this.accountService.getCompanyId();
  }

  constructor(
    private readonly accountService: AuthenticationService,
    private readonly currencyService: CurrencyService,
    private clipboard: Clipboard,
    private readonly countriesService: CountriesService,
    notifierService: NotifierService
  ) {
    this.notifier = notifierService;
    this.getCountries();
  }

  ngOnDestroy(): void {
    this.currencyDetails$?.unsubscribe();
  }

  ngOnInit(): void {
    this.isMobile = window.innerWidth <= 820 ? true : false;

    this.orderCurrency = this.moedas.find(
      (moeda) => moeda.value === this.orderDetails?.currencyDescription
    );
    this.currencyDetails$ = this.currencyService.get(this.currency).subscribe({
      next: (result) => {
        this.currencyDetails = result.data;
      },
    });
  }

  close() {
    this.closeModal.emit(true);
  }

  getCountries() {
    this.countriesService.get().subscribe({
      next: (res) => {
        this.orderCountry = res.data.find(
          (country) => country.id === this.orderDetails?.countrySenderId
        );
      },
    });
  }

  back() {
    this.goBack.emit(true);
  }

  copyText() {
    this.clipboard.copy(
      'Intermediary Bank: ' +
        this.currencyDetails?.intermediaryBankChannels[0]?.bank +
        ' Swift Code: ' +
        this.currencyDetails?.intermediaryBankChannels[0]?.swift +
        ' Account: ' +
        this.currencyDetails?.intermediaryBankChannels[0]?.account +
        ' Address: ' +
        this.currencyDetails?.intermediaryBankChannels[0]?.address +
        ' Beneficiary Bank: ' +
        this.currencyDetails?.beneficiaryBankChannels[0]?.bank +
        ' Swift Code: ' +
        this.currencyDetails?.beneficiaryBankChannels[0]?.swift +
        ' Address: ' +
        this.currencyDetails?.beneficiaryBankChannels[0]?.address +
        ' Beneficiary Account: ' +
        this.currencyDetails?.beneficiaries[0]?.account +
        ' ' +
        this.currencyDetails?.beneficiaries[0]?.nomecliente +
        ' Reference: ' +
        this.currencyDetails?.beneficiaries[0]?.reference
    );
    this.notifier.notify(
      'success',
      'Canal bancário copiado para área de transferência'
    );
  }

  createOrder() {
    this.saveOrder.emit(true);
  }
}
